import React, { ButtonHTMLAttributes, useState } from 'react'

import { t } from '@/i18n'
import { Modal } from '@/components'

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  objectName?: string
}

const FormDeleteButton: React.FC<Props> = ({
  onClick,
  objectName,
  ...rest
}) => {
  const [openModal, setOpenModal] = useState<boolean>(false)

  return (
    <>
      <button
        className="main-btn danger delete-form-button"
        onClick={() => setOpenModal(true)}
        {...rest}
      >
        {t('delete')}
      </button>
      <Modal
        className="delete-confirm"
        visible={openModal}
        title={t('confirm_delete_object', { objectName })}
      >
        <div className="btn-box">
          <button
            type="button"
            className="main-btn gray"
            disabled={rest.disabled}
            onClick={() => setOpenModal(false)}
          >
            {t('cancel')}
          </button>
          <button
            type="button"
            className="main-btn"
            disabled={rest.disabled}
            onClick={onClick}
          >
            {t('delete')}
          </button>
        </div>
      </Modal>
    </>
  )
}

export default FormDeleteButton
